// see .postcssrc
export const phone = matchMedia('(max-width: 559px), (max-height: 499px)');
